import { QueryStringBuilder } from '@/shared/services/queryStringBuilder';
import urljoin from 'url-join';
import { DateOption } from '../models';
import { config } from '@/config/config';
import { api, BlobContent } from '@shared/services/baseApiClient';

class ReportDownloaderService {
  private readonly version = 'v1';

  public getFlowsReportCsv(workspaceId: string, flowId: string, dateOption: DateOption): Promise<BlobContent> {
    const query = new QueryStringBuilder()
      .add('flowId', flowId)
      .add('startDate', dateOption.getDateRange().start.toISOString())
      .add('endDate', dateOption.getDateRange().end.toISOString())
      .add('grouping', dateOption.group)
      .add('format', 'csv')
      .build();

    return this.send(urljoin(config().flowsHost, this.version, workspaceId, `combined-reports`) + query);
  }

  public getMessagingReportCsv(workspaceId: string, dateOption: DateOption): Promise<BlobContent> {
    const query = new QueryStringBuilder()
      .add('startDate', dateOption.getDateRange().start.toISOString())
      .add('endDate', dateOption.getDateRange().end.toISOString())
      .add('grouping', dateOption.group)
      .add('format', 'csv')
      .build();

    return this.send(urljoin(config().messagingHost, this.version, workspaceId, `reports`) + query);
  }

  public getNLPReportCsv(modelId: string, dateOption: DateOption): Promise<BlobContent> {
    const query = new QueryStringBuilder()
      .add('startDate', dateOption.getDateRange().start.toISOString())
      .add('endDate', dateOption.getDateRange().end.toISOString())
      .add('grouping', dateOption.group)
      .add('format', 'csv')
      .build();

    return this.send(urljoin(config().nlpHost, this.version, modelId, `reports`) + query);
  }

  public async getUsageReportCsv(workspaceId: string, dateOption: DateOption): Promise<BlobContent> {
    const query = new QueryStringBuilder()
      .add('startDate', dateOption.getDateRange().start.toISOString())
      .add('endDate', dateOption.getDateRange().end.toISOString())
      .add('format', 'csv')
      .build();

    return this.send(urljoin(config().nlpHost, this.version, 'workspaces', workspaceId, `reports`) + query);
  }

  private async send(url: string) {
    const { data, fileName } = await api.send<BlobContent>('GET', url, undefined, {
      responseType: 'blob',
    });

    return { data, fileName };
  }
}

export const reportDownloaderService = new ReportDownloaderService();
